// appDashboard — Pulpit (Dashboard.tsx). Sesja 16 (POLISH 2026-09-11, MAPA 16-pulpit §2):
// „za dużo tekstu … to musi być prostsze wszędzie”. Pięć sekcji, zero kart poza pierwszym
// uruchomieniem, zero zdań tłumaczących. Klucze lustrzane z ../en/appDashboard.ts.
//
// Reguła, która obowiązuje w tym pliku: KAŻDY string opisuje albo dane, które naprawdę mamy,
// albo czynność, którą użytkownik naprawdę może teraz wykonać. Sekcja bez danych nie dostaje
// zdania o pustce — jej po prostu nie ma (cisza jest informacją). Liczby wstawia ekran
// (mono, tabularne), więc klucze niosą placeholder `{n}` / `{count}` obok słowa w dobrej
// liczbie mnogiej. Pauza = ASCII „-”.
export const appDashboard = {
  common: { untitledSeries: 'Seria bez nazwy', untitledEdit: 'Edit bez nazwy' },
  error: {
    title: 'Nie udało się wczytać Pulpitu',
    body: 'Twoje gemy, edity i pliki są na miejscu - nie udało się tylko odczytać ich stanu.',
  },
  // Pigułka słowna: w wierszu „teraz” i na scenie kafla bez kadru (tylko gdy status ≠ gotowy).
  // `statusLive` / `statusFailed` / `statusRendering` czyta components/AutopilotModal.tsx.
  // R5 (reguła 30): trzy słowa stanu w CAŁYM produkcie, także w tym dawnym słowniku,
  // z którego żyje jeszcze pigułka kafla w Publikacji. Kolejka i render to jedno słowo.
  thumb: {
    queued: 'w kolejce',
    rendering: 'w kolejce',
    failed: 'błąd',
    statusLive: 'gotowy',
    statusFailed: 'błąd',
    statusRendering: 'w kolejce',
  },
  greeting: {
    hi: 'Cześć, {name}',
    hiAnon: 'Cześć',
    newBatch: 'Nowa seria',
    // JEDNO zdanie stanu pod powitaniem, najcięższy stan wygrywa: render nie wyszedł (24 h) >
    // 0 gemów > płatności wyłączone > utwór czeka na tekst > renderuje się. Bezczynnie = brak zdania.
    subRendering_one: 'Jeden edit renderuje się w tle.',
    subRendering_few: '{count} edity renderują się w tle.',
    subRendering_many: '{count} editów renderuje się w tle.',
    subLyrics_one: 'Jeden utwór czeka na poprawki tekstu.',
    subLyrics_few: '{count} utwory czekają na poprawki tekstu.',
    subLyrics_many: '{count} utworów czeka na poprawki tekstu.',
    // Zwrot gemów mówimy WYŁĄCZNIE z ledgera (`refund_confirmed` na każdym nieudanym renderze);
    // w innym razie zdanie bez zwrotu.
    subFailed_one: 'Jeden render nie wyszedł - gemy wróciły.',
    subFailed_few: '{count} rendery nie wyszły - gemy wróciły.',
    subFailed_many: '{count} renderów nie wyszło - gemy wróciły.',
    subFailedPending_one: 'Jeden render nie wyszedł.',
    subFailedPending_few: '{count} rendery nie wyszły.',
    subFailedPending_many: '{count} renderów nie wyszło.',
    subZeroGems: '0 gemów - render nie ruszy.',
    subBillingOff: 'Płatności są chwilowo wyłączone po naszej stronie.',
  },
  // Wiersz faktów zamiast kafli KPI (decyzja 1): trzy liczby, każdy fakt = link; fakt z 0 znika.
  facts: {
    label: 'Stan konta',
    gems: '{gems} = {edits}',
    edits_one: '{count} edit',
    edits_few: '{count} edity',
    edits_many: '{count} editów',
    tracks_one: '{count} utwór',
    tracks_few: '{count} utwory',
    tracks_many: '{count} utworów',
  },
  // „Teraz” bez nagłówka (decyzja 2): tytuł serii jest nagłówkiem; max 4 wiersze.
  // `chunks` czyta components/AutopilotModal.tsx.
  now: {
    readyOf: '{done} z {total}',
    chunks: '{done} z {total} kawałków',
    refundBack: 'gemy wróciły (+{gems})',
    retry_one: 'Ponów · {cost} gem',
    retry_few: 'Ponów · {cost} gemy',
    retry_many: 'Ponów · {cost} gemów',
  },
  recent: {
    allEdits: 'Wszystkie edity',
    title: 'Ostatnie edity',
    editNo: 'edit {n}',
    // `{period}` = liczba + słowo z ekranu („30 dni” / „1 dzień”), bo liczba rządzi rzeczownikiem.
    retentionShort: 'Pliki widzi tylko to konto · dostępne {period}',
    retry: 'Spróbuj ponownie',
  },
  // Autopilot = jeden wiersz faktów (decyzja 7); „wszystkie aktywne” i „nic w planie” = brak faktu.
  publishing: {
    heading: 'Autopilot',
    accounts_one: '{n} konto',
    accounts_few: '{n} konta',
    accounts_many: '{n} kont',
    needsLogin_one: '{n} wymaga logowania',
    needsLogin_few: '{n} wymagają logowania',
    needsLogin_many: '{n} wymaga logowania',
    scheduled_one: '{n} zaplanowany',
    scheduled_few: '{n} zaplanowane',
    scheduled_many: '{n} zaplanowanych',
    next: 'następny {when}',
    zeroLine: 'Autopilot publikuje na Twoich kontach - żadne nie jest jeszcze podłączone.',
    zeroCta: 'Podłącz konto',
  },
  // „Wymaga uwagi”: JEDEN tytuł z nazwą pliku / uchwytem w środku + JEDNA akcja, zero body (decyzja 4).
  attention: {
    title: 'Wymaga uwagi',
    count_one: '{count}',
    count_few: '{count}',
    count_many: '{count}',
    reauth: '{handle} wymaga ponownego logowania',
    fileFailed: '{name}: nie dało się przeanalizować',
    analysisPending: '{name}: analiza w toku',
    instrumental: '{name}: bez słów',
    transcriptRetry: '{name}: transkrypcja do ponowienia',
    beatsRetry: '{name}: rytm do ponowienia',
    lowGems: 'Niski stan: {gems} = {edits}',
  },
  // `music` = przycisk drugorzędny nagłówka; `topup` czyta components/AutopilotModal.tsx,
  // `hooks` — routes/OnboardingView.tsx.
  quick: {
    music: 'Wgraj utwór',
    topup: 'Doładuj gemy',
    hooks: 'Kolekcja hooków',
  },
  // PIERWSZE URUCHOMIENIE = jedna karta (decyzja 8): jedno zdanie, przycisk, formaty, kroki 2 i 3.
  firstRun: {
    title: 'Zacznij od utworu',
    body: 'Wgraj plik - wyłapiemy słowa i beaty, a potem zrobisz z niego pierwsze edity.',
    cta: 'Wgraj utwór',
    formats: 'mp3, wav, flac, m4a · do 200 MB',
    step2Short_one: 'Wybierz klipy - masz już {count} gotową paczkę od nas',
    step2Short_few: 'Wybierz klipy - masz już {count} gotowe paczki od nas',
    step2Short_many: 'Wybierz klipy - masz już {count} gotowych paczek od nas',
    step2ShortNone: 'Wybierz klipy - wgraj własny materiał, potniemy go',
    step3Short: 'Wygeneruj pierwszą serię - kilka editów z jednego fragmentu',
  },
  // Tytuły sygnałów gemów i akcje wierszy „uwagi”; `retryError` = alert po nieudanym ponowieniu.
  signals: {
    billingTitle: 'Płatności są chwilowo wyłączone po naszej stronie',
    zeroTitle: '0 gemów - render nie ruszy',
    openBilling: 'Rozliczenia',
    openMusic: 'Muzyka',
    writeLyrics: 'Wpisz tekst ręcznie',
    uploadAnother: 'Wgraj inną wersję',
    retryTranscript: 'Ponów transkrypcję',
    retryAnalysis: 'Ponów analizę',
    retryError: 'Nie udało się potwierdzić ponowienia. Sprawdź Edity przed kolejną próbą - ponowienie użyje tego samego żądania.',
  },
}
